/*
 * @Author: liyxt
 * @Date: 2020-05-19 15:47:39
 * @LastEditors: liyxt
 * @LastEditTime: 2020-05-28 15:36:49
 * @Description: file content
 */
import React, { Component } from 'react';
import OriginTransfer from 'bee-transfer';

require('bee-transfer/build/Transfer.css');
require('./index.less');

export default class Transfer extends Component {
    render() {
        let { className } = this.props
        return <OriginTransfer {...this.props} className={`nc-transfer ${className}`} />;
    }
}
